import uiRouter from 'angular-ui-router';
import _ from "underscore";
import wizardTpl from "./views/wizard.html"
import wizardController from "./controllers/wizard"
import weblinksTpl from "./views/resources/weblinks.html"
import weblinksController from "./controllers/resources/weblinks"
import weblinksPreviewTpl from "./views/resources/weblinksPreview.html"
import weblinksPreviewController from "./controllers/resources/weblinksPreview"
import referenceBookTpl from "./views/resources/referenceBook.html"
import referenceBookController from "./controllers/resources/referenceBook"
import referenceBookPreviewTpl from "./views/resources/referenceBookPreview.html"
import referenceBookPreviewController from "./controllers/resources/referenceBookPreview"
import googleDocTpl from "./views/resources/googleDoc.html"
import googleDocController from "./controllers/resources/googleDoc"
import googleDocPreviewTpl from "./views/resources/googleDocPreview.html"
import googleDocPreviewController from "./controllers/resources/googleDocPreview"
import utubeVideoTpl from "./views/resources/utubeVideo.html"
import utubeVideoController from "./controllers/resources/utubeVideo"
import utubeVideoPreviewTpl from "./views/resources/utubeVideoPreview.html"
import utubeVideoPreviewController from "./controllers/resources/utubeVideoPreview"
import khanAcademyTpl from "./views/resources/khanAcademy.html"
import khanAcademyController from "./controllers/resources/khanAcademy"
import khanAcademyPreviewTpl from "./views/resources/khanAcademyPreview.html"
import khanAcademyPreviewController from "./controllers/resources/khanAcademyPreview"
import createTpActivityTpl from "./views/activity/createTpActivity.html"
import createTpActivityController from "./controllers/activity/createTpActivity"
import createQuestionTpl from "../../createQuestion/views/createQuestion.html"
import createQuestionController from "../../createQuestion/controllers/createQuestionController"
import formatQpTpl from "./views/activity/formatQp.html"
import formatQpController from "./controllers/activity/formatQp"
import flashTpl from "./views/resources/flash.html"
import flashController from "./controllers/resources/flash"
import flashPreviewTpl from "./views/resources/flashPreview.html"
import flashPreviewController from "./controllers/resources/flashPreview"
import videoTpl from "./views/resources/video.html"
import videoController from "./controllers/resources/video"
import videoPreviewTpl from "./views/resources/videoPreview.html"
import videoPreviewController from "./controllers/resources/videoPreview"
import pdfTpl from "./views/resources/pdf.html"
import pdfController from "./controllers/resources/pdf"
import pdfPreviewTpl from "./views/resources/pdfPreview.html"
import pdfPreviewController from "./controllers/resources/pdfPreview"
import './wizard.scss'
import qpPreviewTpl from './views/activity/tpActivityPreview.html'
import qpPreviewCtrl from './controllers/activity/tpActivityPreview'
import qpSummaryPreviewTpl from './views/activity/qpSummaryPreview.html'
import qpSummaryPreviewCtrl from './controllers/activity/qpSummaryPreview'
import submissionListTpl from './views/activity/submissionList.html'
import submissionListCtrl from './controllers/activity/submissionList'
import attendExamTpl from './views/activity/attendExam.html'
import attendExamCtrl from './controllers/activity/attendExam'
import questionDirectiveTpl from './views/activity/questionDirective.html'
import questionDirectiveCtrl from './controllers/activity/questionDirective'

import teacherAnswerViewTpl from '../../traditionalActivity/views/teacherAnswerView.html'
import teacherAnswerViewCtrl from '../../traditionalActivity/controllers/teacherAnswerView'
import studentAnswerViewTpl from '../../traditionalActivity/views/studentAnswerView.html'
import studentAnswerViewCtrl from '../../traditionalActivity/controllers/studentAnswerView'
import reportsPreviewTpl from './views/reports/reports.html'
import reportsPreviewCtrl from './controllers/reports/reports'
import activityReportsTpl from './views/reports/activityReports.html'
import activityReportsCtrl from './controllers/reports/activityReports'
import singleActivityReportTpl from './views/reports/singleActivityReport.html'
import singleActivityReportCtrl from './controllers/reports/singleActivityReport'
import studentActivityReportTpl from './views/reports/studentActivityReport.html'
import studentActivityReportCtrl from './controllers/reports/studentActivityReport'
import studentLearningProgressTpl from './views/reports/studentViewLearningProgress.html'
import studentLearningProgressCtrl from './controllers/reports/studentViewLearningProgress'
import teacherLearningProgressTpl from './views/reports/teacherViewLearningProgress.html'
import teacherLearningProgressCtrl from './controllers/reports/teacherViewLearningProgress'
import singlePracticeReportTpl from './views/reports/singlePracticeActivityReport.html'
import singlePracticeReportCtrl from './controllers/reports/singlePracticeActivityReport'
import studentPracticeReportTpl from './views/reports/studentPracticeActivityReport.html'
import studentPracticeReportCtrl from './controllers/reports/studentPracticeActivityReport'
import practiceActivityReportsTpl from './views/reports/practiceActivityReports.html'
import practiceActivityReportsCtrl from './controllers/reports/practiceActivityReports'

var module = angular.module('TpWizardModule', [
        uiRouter
    ]).component('attendExam', {
        template: attendExamTpl,
        controllerAs: 'attendExamCtrl',
        controller: attendExamCtrl
    })
    .component('activityReports', {
        template: activityReportsTpl,
        controllerAs: 'activityReportsCtrl',
        controller: activityReportsCtrl
    })
     .component('studentActivityReports', {
        template: studentActivityReportTpl,
        controllerAs: 'studentActivityReportCtrl',
        controller: studentActivityReportCtrl
    })
    .component('studentLearningProgress', {
        template: studentLearningProgressTpl,
        controllerAs: 'studentLearningProgressCtrl',
        controller: studentLearningProgressCtrl
    })
    .component('teacherLearningProgress', {
        template: teacherLearningProgressTpl,
        controllerAs: 'teacherLearningProgressCtrl',
        controller: teacherLearningProgressCtrl
    })
     .component('practiceActivityReports', {
        template: practiceActivityReportsTpl,
        controllerAs: 'practiceActivityReportsCtrl',
        controller: practiceActivityReportsCtrl
    })
    .component('singlePracticeReport', {
        template: singlePracticeReportTpl,
        controllerAs: 'singlePracticeReportCtrl',
        controller: singlePracticeReportCtrl
    })
    .component('studentPracticeReport', {
        template: studentPracticeReportTpl,
        controllerAs: 'studentPracticeReportCtrl',
        controller: studentPracticeReportCtrl
    })
    .controller('wizardController', wizardController)

module.constant('TPWIZARDCONSTANT', {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
       // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs",
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
       // flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../../img/auth/pdf.png",
       // flash: "../../../../../src/img/auth/interactive_anime.png",
        video: '../../../../../img/auth/video.png',
        weblinks: '../../../../../img/auth/web.png',
        refbooks: '../../../../../img/auth/refbook.png',
        activityForm: '../../../../../img/auth/activity.png',
        khanAcademy: '../../../../../img/auth/khan_academy.png',
        utubeVideo: '../../../../../img/auth/utube.png',
        googleDocs: "../../../../../img/auth/google_docs.png",
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_SAVE_WEBLINK: "/v0/tp-resources/weblink/save",
    API_SAVE_REFBOOK: "/v0/tp-resources/refbook/save",
    API_SAVE_GOOGLEDOCS: "/v0/tp-resources/googledoc/save",
    API_SAVE_UTUBE: "/v0/tp-resources/youtube/save",
    API_SAVE_KHANACADEMY: "/v0/tp-resources/khanacademy/save",
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/",
    API_GET_FORMAT_QP: "/v0/tp-activity/format-qp",
    API_GET_TP_ACTIVITY: "/v0/tp-activity/get-activity/",
    API_SAVE_SECTION: "/v0/tp-activity/save-section",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_QUESTION: "/v0/tp-activity/add-questions",
    API_AUTO_FORMAT: "/v0/tp-activity/auto-format",
    API_SELECT_QP: "/v0/tp-activity/create-qp-from-qp",
    API_SELECT_TEMPLATE: "/v0/tp-activity/qp/template",
    API_GET_QP_SUMMARY: "/v0/tp-activity/summary/",
    API_SAVE_FLASH: "/v0/tp-resources/flash/save",
    API_SAVE_VIDEO: "/v0/tp-resources/video/save",
    API_SAVE_PDF: "/v0/tp-resources/pdf/save",
    API_ADD_PDF_ANNOTATION: '/v0/tp-resources/annotation/add-annotation',
    API_FETCH_ANNOTATION: "/v0/tp-resources/annotation/fetch",
    API_REMOVE_ANNOTATION: "/v0/tp-resources/annotation/remove-page-annotation",
    API_UPDATE_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-page-annotation",
    API_UPDATE_ALL_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-all-page-annotation",
    API_APPROVE_RESOURCE:"/v0/tp-resources/approve-resource",
    API_GET_ACTIVITY_REPORT:"/v0/tp-reports/assessment-activity-based-report/",
    API_APPROVE_RESOURCE: "/v0/tp-resources/approve-resource",
    API_GET_STUDENTS: "/v0/tp-reports/student-details",
    API_GET_ALL_ACTIVITY: "/v0/tp-reports/activity-list/",
    API_ADD_LEARNING_PROGRESS: "/v0/tp-resources/learning-progress/save",
    API_ADD_NOTES: "/v0/tp-resources/add-note",
    API_GET_PREV_NOTES: "/v0/tp-resources/get-previous-note",
    API_GET_STUDENT_REPORT:"/v0/tp-reports/assessment-activity-student-based-report/",
    API_GET_ASSIGNED_RESOURCES:"/v0/tp-reports/assigned-resources/",
    API_GET_LEARNING_PROGRESS:"/v0/tp-reports/learning-progress",
    API_GET_ALL_PRACTICE_ACTIVITY: "/v0/tp-reports/practice-activity-list/",
    API_GET_PRACTICE_ACTIVITY_REPORT:"/v0/tp-reports/practice-activity-based-report/",
    API_GET_STUDENT_PRACTICE_REPORT:"/v0/tp-reports/practice-activity-student-based-report/",
    API_COMPLETE_RESOURCE:"/v0/teachingPlan/resource-complete/",
})

module.config(function($stateProvider) {
    "ngInject";

    $stateProvider
        /*.state('wizard', {
            parent: 'app',
            url: '/wizard/:planId',
            views: {
                '@': {
                    template: wizardTpl,
                    controller: wizardController,
                    controllerAs: 'wizard'
                }
            }
        })*/
        .state('weblinks', {
            parent: 'wizard',
            url: '/weblinks/:resourceId',
            views: {
                'tpWizardView': {
                    template: weblinksTpl,
                    controller: weblinksController,
                    controllerAs: 'weblinks'
                }
            }
        })
        .state('weblinksPreview', {
            parent: 'wizard',
            url: '/weblinks-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: weblinksPreviewTpl,
                    controller: weblinksPreviewController,
                    controllerAs: 'weblinksPreview'
                }
            }
        })
        .state('refbooks', {
            parent: 'wizard',
            url: '/reference-book/:resourceId',
            views: {
                'tpWizardView': {
                    template: referenceBookTpl,
                    controller: referenceBookController,
                    controllerAs: 'referenceBook'
                }
            }
        })
        .state('refbooksPreview', {
            parent: 'wizard',
            url: '/reference-book-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: referenceBookPreviewTpl,
                    controller: referenceBookPreviewController,
                    controllerAs: 'referenceBookPreview'
                }
            }
        })
        .state('googleDocs', {
            parent: 'wizard',
            url: '/google-doc/:resourceId',
            views: {
                'tpWizardView': {
                    template: googleDocTpl,
                    controller: googleDocController,
                    controllerAs: 'googleDoc'
                }
            }
        })
        .state('googleDocsPreview', {
            parent: 'wizard',
            url: '/google-doc-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: googleDocPreviewTpl,
                    controller: googleDocPreviewController,
                    controllerAs: 'googleDocPreview'
                }
            }
        })
        .state('utubeVideo', {
            parent: 'wizard',
            url: '/you-tube/:resourceId',
            views: {
                'tpWizardView': {
                    template: utubeVideoTpl,
                    controller: utubeVideoController,
                    controllerAs: 'utubeVideo'
                }
            }
        })
        .state('utubeVideoPreview', {
            parent: 'wizard',
            url: '/you-tube-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: utubeVideoPreviewTpl,
                    controller: utubeVideoPreviewController,
                    controllerAs: 'utubeVideoPreview'
                }
            }
        })
        .state('khanAcademy', {
            parent: 'wizard',
            url: '/khan-academy/:resourceId',
            views: {
                'tpWizardView': {
                    template: khanAcademyTpl,
                    controller: khanAcademyController,
                    controllerAs: 'khanAcademy'
                }
            }
        })
        .state('khanAcademyPreview', {
            parent: 'wizard',
            url: '/khan-academy-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: khanAcademyPreviewTpl,
                    controller: khanAcademyPreviewController,
                    controllerAs: 'khanAcademy'
                }
            }
        })
        .state('activityForm', {
            parent: 'wizard',
            url: '/create-tp-activity/:resourceId',
            views: {
                'tpWizardView': {
                    template: createTpActivityTpl,
                    controller: createTpActivityController,
                    controllerAs: 'createTpActivity'
                }
            }
        })
        .state('createTpQuestion', {
            parent: 'wizard',
            url: '/create-tp-question',
            views: {
                'tpWizardView': {
                    template: createQuestionTpl,
                    controller: createQuestionController,
                    controllerAs: 'createTpQuestion'
                }
            }
        })
        .state('formatQp', {
            parent: 'wizard',
            url: '/format-qp/:resourceId',
            views: {
                'tpWizardView': {
                    template: formatQpTpl,
                    controller: formatQpController,
                    controllerAs: 'formatQp'
                }
            }
        })
        .state('tpActivityPreview', {
            parent: 'wizard',
            url: '/tp-activity-preview/:qpId',
            views: {
                'tpWizardView': {
                    template: qpPreviewTpl,
                    controller: qpPreviewCtrl,
                    controllerAs: 'qpPreviewCtrl'
                }
            }
        })
        .state('activityFormPreview', {
            parent: 'wizard',
            url: '/qp-summary-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: qpSummaryPreviewTpl,
                    controller: qpSummaryPreviewCtrl,
                    controllerAs: 'qpSummaryPreviewCtrl'
                }
            }
        })
        .state('submissionList', {
            parent: 'wizard',
            url: '/activity-submission-list/:qpId',
            views: {
                'tpWizardView': {
                    template: submissionListTpl,
                    controller: submissionListCtrl,
                    controllerAs: 'submissionListCtrl'
                }
            }
        })
        .state('attendExam', {
            parent: 'wizard',
            url: '/attend-exam/:qpId',
            views: {
                'tpWizardView': {
                    template: attendExamTpl,
                    controller: attendExamCtrl,
                    controllerAs: 'attendExamCtrl'
                }
            }
        })
        .state('questionDirective', {
            parent: 'wizard',
            url: '/question-selection/:qpId/:activityId',
            views: {
                'tpWizardView': {
                    template: questionDirectiveTpl,
                    controller: questionDirectiveCtrl,
                    controllerAs: 'questionDirectiveCtrl'
                }
            }
        })
        .state('flash', {
            parent: 'wizard',
            url: '/flash/:resourceId',
            views: {
                'tpWizardView': {
                    template: flashTpl,
                    controller: flashController,
                    controllerAs: 'flash'
                }
            }
        })
        .state('flashPreview', {
            parent: 'wizard',
            url: '/flash-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: flashPreviewTpl,
                    controller: flashPreviewController,
                    controllerAs: 'flash'
                }
            }
        })
        .state('video', {
            parent: 'wizard',
            url: '/video/:resourceId',
            views: {
                'tpWizardView': {
                    template: videoTpl,
                    controller: videoController,
                    controllerAs: 'video'
                }
            }
        })
        .state('videoPreview', {
            parent: 'wizard',
            url: '/video-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: videoPreviewTpl,
                    controller: videoPreviewController,
                    controllerAs: 'video'
                }
            }
        })
        .state('pdf', {
            parent: 'wizard',
            url: '/pdf/:resourceId',
            views: {
                'tpWizardView': {
                    template: pdfTpl,
                    controller: pdfController,
                    controllerAs: 'pdf'
                }
            }
        })
        .state('pdfPreview', {
            parent: 'wizard',
            url: '/pdf-preview/:resourceId',
            views: {
                'tpWizardView': {
                    template: pdfPreviewTpl,
                    controller: pdfPreviewController,
                    controllerAs: 'pdf'
                }
            }
        })
        .state('teacherAnswerPreview', {
            parent: 'wizard',
            url: '/teacher-answer-preview/:qpId/:studentId',
            views: {
                'tpWizardView': {
                    template: teacherAnswerViewTpl,
                    controller: teacherAnswerViewCtrl,
                    controllerAs: 'teacherAnswerViewCtrl'
                }
            }
        })
        .state('studentAnswerPreview', {
            parent: 'wizard',
            url: '/teacher-answer-preview/:qpId',
            views: {
                'tpWizardView': {
                    template: studentAnswerViewTpl,
                    controller: studentAnswerViewCtrl,
                    controllerAs: 'studentAnswerViewCtrl'
                }
            }
        })
        .state('reportsPreview', {
            parent: 'wizard',
            url: '/reports-preview',
            views: {
                'tpWizardView': {
                    template: reportsPreviewTpl,
                    controller: reportsPreviewCtrl,
                    controllerAs: 'reportsPreviewCtrl'
                }
            }
        })
        .state('activityReports', {
            parent: 'wizard',
            url: '/activity-reports',
            views: {
                'tpWizardView': {
                    template: activityReportsTpl,
                    controller: activityReportsCtrl,
                    controllerAs: 'activityReportsCtrl'
                }
            }
        })
        .state('singleActivityReports', {
            parent: 'wizard',
            url: '/single-activity-reports/:qpId',
            views: {
                'tpWizardView': {
                    template: singleActivityReportTpl,
                    controller: singleActivityReportCtrl,
                    controllerAs: 'singleActivityReportCtrl'
                }
            }
        })
        .state('studentActivityReports', {
            parent: 'wizard',
            url: '/student-activity-reports/:studentId/:isShowGoBack',
            views: {
                'tpWizardView': {
                    template: studentActivityReportTpl,
                    controller: studentActivityReportCtrl,
                    controllerAs: 'studentActivityReportCtrl'
                }
            }
        })
        .state('studentLearningProgress', {
            parent: 'wizard',
            url: '/student-learning-progress/:studentId/:isShowGoBack',
            views: {
                'tpWizardView': {
                    template: studentLearningProgressTpl,
                    controller: studentLearningProgressCtrl,
                    controllerAs: 'studentLearningProgressCtrl'
                }
            }
        })
        .state('teacherLearningProgress', {
            parent: 'wizard',
            url: '/teacher-learning-progress/:studentId/:isShowGoBack',
            views: {
                'tpWizardView': {
                    template: teacherLearningProgressTpl,
                    controller: teacherLearningProgressCtrl,
                    controllerAs: 'teacherLearningProgressCtrl'
                }
            }
        })
        .state('practiceActivityReports', {
            parent: 'wizard',
            url: '/activity-reports',
            views: {
                'tpWizardView': {
                    template: practiceActivityReportsTpl,
                    controller: practiceActivityReportsCtrl,
                    controllerAs: 'practiceActivityReportsCtrl'
                }
            }
        })
        .state('singlePracticeReport', {
            parent: 'wizard',
            url: '/single-practice-reports/:qpId',
            views: {
                'tpWizardView': {
                    template: singlePracticeReportTpl,
                    controller: singlePracticeReportCtrl,
                    controllerAs: 'singlePracticeReportCtrl'
                }
            }
        })
        .state('studentPracticeReport', {
            parent: 'wizard',
            url: '/student-practice-reports/:studentId/:isShowGoBack',
            views: {
                'tpWizardView': {
                    template: studentPracticeReportTpl,
                    controller: studentPracticeReportCtrl,
                    controllerAs: 'studentPracticeReportCtrl'
                }
            }
        })
});


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/wizardModule.js